import { useTranslation } from 'react-i18next';
import { CheckCheck, ClipboardList, OctagonX } from 'lucide-react';

type RequestStateValueProps = {
  value?: number;
};

export function GradeStateValue(props: RequestStateValueProps) {
  const { value } = props;
  const { t } = useTranslation();

  return value === 1 ? (
    <>
      <OctagonX className="h-5 w-5 text-red-600" />
      <span className="m-2">{t('rejected')}</span>
    </>
  ) : value === 2 ? (
    <>
      <CheckCheck className="h-5 w-5 text-green-700" />
      <span className="m-2">{t('approved')}</span>
    </>
  ) : (
    <>
      <ClipboardList className="h-5 w-5 text-cyan-600" />
      <span className="m-2">{t('pending')}</span>
    </>
  );
}
